import { compute, type Options } from 'compute-scroll-into-view';

export const scrollIntoView = (target: Element, options: Options) => {
  const actions = compute(target, options);
  actions.forEach(({ el, top, left }) => {
    el.scrollTop = top;
    el.scrollLeft = left;
  });
};
